import React from "react";
import { makeStyles, Box } from "@material-ui/core";

import LinkItem from "./LinkItem";

export default function MenuItem({ bottomEffect, text, hovered, selected, external, href, onMouseEnter, icon }) {
  const classes = useStyle({ hovered, bottomEffect });

  return (
    <Box className={classes.container} onMouseEnter={onMouseEnter} px={1}>
      <LinkItem selected={selected} hovered={hovered} external={external} href={href}>
        {text}
      </LinkItem>
      {icon}
    </Box>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    whiteSpace: "nowrap",
    width: "100%",
    position: "relative",
    color: "white",
    padding: 0,
    "&: hover": { color: theme.palette.primary.main },
  },
}));
